// ClosePopupConfirmationPopup.tsx

import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '../../../components/ui/dialog';

interface ClosePopupConfirmationPopupProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ClosePopupConfirmationPopup: React.FC<
  ClosePopupConfirmationPopupProps
> = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-sm rounded-2xl">
        <DialogHeader>
          <DialogTitle className="text-base font-bold text-black">
            Quit Adding New Payment Method?
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-gray-600">
          Changes you made so far will not be saved.
        </p>
        <div className="mt-4 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-gray-300 px-5 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            No
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded-xl bg-[#5CB891] px-5 py-2 text-sm font-semibold text-white hover:bg-[#4aa07c]"
          >
            Yes
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClosePopupConfirmationPopup;
